import { type FC } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputTypeSelectBox } from "@clientFrontend/components/InputTypeSelectBox";
import { wrapper } from "./styles.css";

type Props = {
  name: string;
  placeholder: string;
  defaultValue?: OptionProps;
  options: OptionProps[];
};

type OptionProps = {
  value: string | number;
  label: string;
};

type FormData = Record<string, string | number>;

export const SelectWithSearchOption: FC<Props> = ({ name, placeholder, defaultValue, options }) => {
  const { control } = useForm<FormData>();

  return (
    <div className={wrapper}>
      <Controller
        name={name}
        control={control}
        render={() => (
          <InputTypeSelectBox
            name={name}
            options={options}
            placeholder={placeholder}
            defaultValue={defaultValue}
          />
        )}
      />
    </div>
  );
};
